import { useEffect } from 'react';
import { useEditorStore } from './editor-store';

const isEditableTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement &&
  (target.isContentEditable ||
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement);

/**
 * 에디터 단축키(스펙 §6-3) — Cmd/Ctrl+Z undo, Cmd/Ctrl+Shift+Z·Ctrl+Y redo. 입력 칸 안에서는 브라우저 기본 되돌리기를 둔다.
 * 되돌릴 것이 없으면 기본 동작을 막지 않는다.
 */
export const useEditorShortcuts = (): void => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!(event.metaKey || event.ctrlKey) || event.altKey || isEditableTarget(event.target))
        return;
      const key = event.key.toLowerCase();
      const isRedo =
        (key === 'z' && event.shiftKey) || (key === 'y' && event.ctrlKey && !event.shiftKey);
      const isUndo = key === 'z' && !event.shiftKey;
      const store = useEditorStore.getState();
      if (isUndo && store.past.length > 0) {
        event.preventDefault();
        store.undo();
      } else if (isRedo && store.future.length > 0) {
        event.preventDefault();
        store.redo();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
};
